export const useDevice = defineStore("device", () => {
  const isH5 = useState(() => true);
  const userAgent = useRequestHeader("user-agent");
  const { pathname } = onDiff(() => location, useRequestURL);
  const first = pathname?.split("/")[1] ?? "";
  isH5.value = /mobile/i.test(userAgent ?? "");

  return {
    isH5,
  };
});
